import ToolAlignment from './ToolAlignment';
import { type Alignment } from '../../../types/aha-editor';

class ToolAlignRight extends ToolAlignment {
  static toolName = 'Right align';
  static iconClass = 'fa-regular fa-align-right';
  static alignment: Alignment = 'right';
  static shortcut = 'Cmd+Shift+r';
}

export default ToolAlignRight;
